import { log, ADAPTER_STATUS } from '@web3auth/base';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MODAL_STATUS } from '../interfaces.js';
import i18nInstance from '../localeImport.js';
import Icon from './Icon.js';
import Image from './Image.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const closeIcon = /*#__PURE__*/jsx(Icon, {
  iconName: "x-light",
  darkIconName: "close"
});
function DetailedLoader(props) {
  const {
    adapter,
    appLogo,
    message,
    modalStatus,
    adapterName,
    onClose
  } = props;
  const providerIcon = adapter === "twitter" ? /*#__PURE__*/jsx(Image, {
    imageId: "login-x-dark"
  }) : /*#__PURE__*/jsx(Image, {
    imageId: `login-${adapter}`,
    height: "30",
    width: "30"
  });
  const [t] = useTranslation(undefined, {
    i18n: i18nInstance
  });
  useEffect(() => {
    log.debug("adapter loader re-rendering");
    if (modalStatus === MODAL_STATUS.CONNECTED) {
      setTimeout(() => {
        onClose();
      }, 3000);
    }
  }, [modalStatus, onClose]);
  return modalStatus !== MODAL_STATUS.INITIALIZED ? /*#__PURE__*/jsxs("div", {
    className: "w3ajs-modal-loader w3a-modal__loader w3a--h-full",
    children: [/*#__PURE__*/jsx("div", {
      className: "w3a-modal__loader-content",
      children: /*#__PURE__*/jsxs("div", {
        className: "w3a-modal__loader-info",
        children: [modalStatus === MODAL_STATUS.CONNECTING && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("div", {
            className: "w3a-modal__loader-bridge",
            children: [/*#__PURE__*/jsxs("div", {
              className: "w3a-modal__loader-app-logo",
              children: [/*#__PURE__*/jsx("img", {
                src: appLogo,
                className: "w3a--block dark:w3a--hidden w3a--h-10 w3a--w-10",
                alt: ""
              }), /*#__PURE__*/jsx("img", {
                src: appLogo,
                className: "w3a--hidden dark:w3a--block w3a--h-10 w3a--w-10",
                alt: ""
              })]
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__connector",
              children: /*#__PURE__*/jsxs("div", {
                className: "w3a-modal__connector-beat",
                children: [/*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {}), /*#__PURE__*/jsx("div", {})]
              })
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-social-logo",
              children: providerIcon
            })]
          }), /*#__PURE__*/jsxs("div", {
            children: [/*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-bridge-message",
              children: t("modal.adapter-loader.message1", {
                adapter: adapterName
              })
            }), /*#__PURE__*/jsx("div", {
              className: "w3a-modal__loader-bridge-message",
              children: t("modal.adapter-loader.message2", {
                adapter: adapterName
              })
            })]
          })]
        }), modalStatus === ADAPTER_STATUS.CONNECTED && /*#__PURE__*/jsxs("div", {
          className: "w3a--flex w3a--flex-col w3a--items-center",
          children: [/*#__PURE__*/jsx(Icon, {
            iconName: "connected"
          }), /*#__PURE__*/jsx("div", {
            className: "w3ajs-modal-loader__message w3a-spinner-message w3a--mt-4",
            children: message
          })]
        }), modalStatus === ADAPTER_STATUS.ERRORED && /*#__PURE__*/jsx("div", {
          className: "w3ajs-modal-loader__message w3a-spinner-message w3a-spinner-message--error",
          children: message
        })]
      })
    }), (modalStatus === ADAPTER_STATUS.CONNECTED || modalStatus === ADAPTER_STATUS.ERRORED) && /*#__PURE__*/jsx("button", {
      type: "button",
      className: "w3a-header__button w3ajs-loader-close-btn",
      onClick: onClose,
      children: closeIcon
    })]
  }) : null;
}

export { DetailedLoader as default };
